import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import {getMyPosts} from '../../services/servicesGetMyPosts';
import {IconAiOutlineArrowUp} from './stylePreview';
import {DivPrincipal,DivFlexPostsBlog,DivPost,DivLink,ImgPost,DivImg,MyBtn} from './stylePreview';
import MenuPreview from './menuPreview';
import RodapePreview from './rodapePreview';
import {URLIMG} from '../../helpers/constantes';

export default function Preview(){
    const [post, setPost] = useState([]);
    const scrollRef = useRef();
    const [mostraBotao, setMostraBotao] = useState(false);
    const heightReal = window.screen.height - 50;


    async function carregaPost()
    {

        const resultPosts = await getMyPosts();
        setPost(resultPosts);
    };

    // function EscondeDiv(){
    //     let divSelecionada = document.getElementById('body');
    //     divSelecionada.style.overflow ='hidden';
    //     divSelecionada.style.padding ='0';
    //     divSelecionada.style.margin ='0';
    //     divSelecionada.style.height ='100vh';

    // }

    function GoToTop(){
        scrollRef.current.scrollTop = 0;
    }

    function ScrollTop(){
        if(scrollRef.current.scrollTop > 200){
            setMostraBotao(true);
        }else if(scrollRef.current.scrollTop < 200){
            setMostraBotao(false);
        }

    }

    useEffect(()=>{
        carregaPost();
    },[]);

    return(
        <DivPrincipal id='top' heightReal={heightReal} ref={scrollRef} onScroll={()=>ScrollTop()}>
            {/* <div onClick={()=>{EscondeDiv()}}>Esconde Menu</div> */}
            <MenuPreview/>
            <h1 style={{margin:'0 0 20px 150px'}}>Blog</h1>
            <DivFlexPostsBlog>
                <MyBtn onClick={GoToTop} display={mostraBotao?'block':'none'} id='botao'><IconAiOutlineArrowUp /></MyBtn>
                {post.map(item=>{
                    return(
                        <DivPost key={item.Id} >
                            <DivLink  style={{width:'100%',height:'100%'}}>
                                <Link to={`preview/post_id/${item.Id}`}>
                                    <DivImg style={{width:'100%',height:'100%'}} >
                                        <ImgPost style={{width:'100%',height:'100%'}} src={URLIMG + item.Image1} />
                                    </DivImg>
                                    <div style={{display:'none',width:'100%',fontFamily:'Ubuntu',fontSize:'20pt',padding:'5px'}}>
                                        {item.PostTitle}
                                    </div>
                                </Link>
                            </DivLink>
                        </DivPost>
                    )
                })}

            </DivFlexPostsBlog>
            <RodapePreview/>
        </DivPrincipal>
    )
}
